import React from 'react';
import './departement.css';
import { Footer, Header } from '../index';
import { Link } from 'react-router-dom';
import directeurM from'../../asserts/images/directeurMath.jpg';

function Departementmath(props) {
  return (
    <div style={{ backgroundColor: '#FCFCFC' }}>
      <Header />
      <div className='containerMATH'>
        <div className='bgMATH'>  </div>
        <div className="container-fluid text-white text-center" style={{ position: 'relative', marginTop: '-160px', marginBottom: '100px' }}>
          <h1 style={{fontFamily:'fantasy', fontSize:'45px'}}className="container-fluid text-white text-center" id='h1math'>Département Mathématiques</h1>
          <p ><Link className='linkdep' to="/">Accueil</Link> <span>{'>'}</span><Link className='linkdep'
            to="/"> Département </Link>  <span>{'>'}</span> <Link className='linkdep'
            to="/">Mathématiques</Link></p></div>
      </div>
      
      <div className="DEP" style={{ backgroundColor: '#FCFCFC' }}>
      <div className='boxdep1'>
      <h1 className="container-fluid text-center" style={{color:'#162533' }}>Directeur De Département</h1>
        <div className='pres'>
            <div className='IMAGE'>    
                 <img src={directeurM} alt="intro" />               
            </div>
            <div className='coordonne'><p><span>Nom : </span>Mohamed ELOUED <br/> <span>Email : </span><a href=''> wadyel@yahoo.fr</a> </p> </div>

        </div>
      </div>
      <div className='boxdep2'>
      <h1 className="container-fluid text-center" style={{color:'#162533' }}>Présentation</h1>
        <p className='parag'>
        <br/>
        Le département de mathématiques appliquées à l'Institut Supérieur d'Informatique et de Mathématiques de Monastir 
        (ISIMM) se distingue par son engagement à fournir une formation de pointe dans le domaine des mathématiques appliquées.
          Fort de son corps professoral hautement qualifié et passionné, le département s'efforce de doter les étudiants
           des connaissances théoriques et pratiques nécessaires pour aborder efficacement les défis complexes rencontrés 
           dans divers .
           À travers des programmes académiques rigoureux et des projets de recherche novateurs, 
           les étudiants de LISIMM acquièrent une solide compréhension des principes mathématiques 
           fondamentaux et développent des compétences analytiques et de résolution de problèmes 
           qui sont essentielles dans le paysage professionnel moderne.
        </p>
      </div>

      

      </div>
      <Footer />
    </div>
  )
}

export default Departementmath;
 /*<a target="_blank" href="/images/organigramme.jpg">
    </a>*/